import React, {useEffect, useState} from 'react';
import {useDynamicScript} from './useDynamicScript';

const loadComponent = async (scope, module) => {
    await __webpack_init_sharing__('default');
    const container: any = window[scope];
    await container.init(__webpack_share_scopes__.default);
    const factory = await container.get(module);
    const Module = factory();
    return Module;
};

type PropsType = {
    remoteAppInfo: {
        module: string;
        scope: string;
        url: string;
    };
    skeleton: React.ReactNode;
    props: any;
};
const DynamicRemoteApp = ({
    remoteAppInfo: {module, scope, url},
    skeleton = <div />,
    props,
}: PropsType) => {
    const [remoteModule, setRemoteModule] = useState<null | React.ReactNode>(null);
    const {ready} = useDynamicScript(url);

    useEffect(() => {
        const load = async () => {
            if (ready && !remoteModule) {
                const fetchedModule = await loadComponent(scope, module);
                setRemoteModule(fetchedModule.mount(props));
            }
        };
        load();
    }, [remoteModule, ready, module, scope, props]);

    return <>{remoteModule || skeleton}</>;
};

export default React.memo(DynamicRemoteApp, () => true);
